import _ from 'underscore';
import { getFlattenedImageAssetList, updateAssetsIdsAsync, setMTImageModel, getImagesFromMTAssetsAsync } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';
import { ImageOData } from '@bingads-webui-campaign/image-odata';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';

export const getODataConfig = (serverContext) => {
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
      hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    odataToken: serverContext.Token,
    oDataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
    oDataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
  };

  return oDataConfig;
};

export const processImageListViewModelToModel = (imageListVm, serverContext, cid, aid) => {
  const imageOData = new ImageOData(cid, aid, getODataConfig(serverContext));
  const flattenedIncludedImageAssetList = getFlattenedImageAssetList(imageListVm, true /* isMultimediaAdinMSANEnabled */, false /* isMultimediaAd */);
  const originalData = {};

  return updateAssetsIdsAsync(flattenedIncludedImageAssetList, 0, true /* isAdCreatorEnabled */, imageOData)
    .then((updates) => {
      // isMultimediaAdinMSANEnabled unset because right now pmax MT does not support autofill (we have to specify all included aspect ratios - no data optimizations)
      // TODO: Refactor code to have more calrity on functionality specifying isMultimediaAdinMSANEnabled and isMultimediaAd values
      setMTImageModel(
        originalData,
        updates,
        _.map(imageListVm, imageArray => _.filter(imageArray, imageObj => imageObj.isIncluded)) /* imageList */,
        {
          isMultimediaAdinMSANEnabled: false,
          isMultimediaAd: false,
        },
        [] /* UiUnsupportedRatios */
      );
      return originalData;
    });
};

export const processImageListModelToViewModel = (imageAssetArray, cid, aid, overrideParameters) => {
  const baseUrl = `/Customers(${cid})/Accounts(${aid})/`;
  const isCombinedMsanAndMmaAspectRatios = overrideParameters && overrideParameters.isCombinedMsanAndMmaAspectRatios !== undefined ? overrideParameters.isCombinedMsanAndMmaAspectRatios : true;
  const isLinkedInAd = overrideParameters && overrideParameters.isLinkedInAd !== undefined ? overrideParameters.isLinkedInAd : false;
  const isPMaxAspectRatiosV2Enabled = overrideParameters && overrideParameters.isPMaxAspectRatiosV2Enabled;

  const promise = getImagesFromMTAssetsAsync(
    odata,
    baseUrl,
    imageAssetArray,
    true /* isMultimediaAd */,
    true /* isAdCreatorEnabled */,
    isCombinedMsanAndMmaAspectRatios, /* isCombinedMsanAndMmaAspectRatios */
    false /* isStoreAppProng */,
    false /* isStoreAppSpotLight */,
    false /* isStoreAppTransparentLogo */,
    isLinkedInAd /* isLinkedInAd */,
    false /* isImageFittingEnabled */,
    isPMaxAspectRatiosV2Enabled
  );

  return createAsyncToken(promise);
};
